import AxiosControl from '../components/axios/AxiosControl'
import { getErrorMessage, getResponseData, getResponseMessage, isSuccessResponse } from '../helpers/apiResponse'
const Axios = AxiosControl()

export const getTemplates = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/product-template/getAll', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'TEMPLATE_GETALL_SUCCESS',
                payload: getResponseData(data)
            })
        }
    } catch (error) {
        dispatch({
            type: 'TEMPLATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const getTemplate = (templateId) => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/product-template/get/' + templateId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'TEMPLATE_GET_SUCCESS',
                payload: getResponseData(data).template
            })
        }
    } catch (error) {
        dispatch({
            type: 'TEMPLATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const createTemplate = (templateData) => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/product-template/create', templateData, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'TEMPLATE_ADD_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'TEMPLATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const editTemplate = (templateId, templateData) => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.put('/api/product-template/edit/' + templateId, templateData, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            const responseData = getResponseData(data)
            dispatch({
                type: 'TEMPLATE_EDIT_SUCCESS',
                payload: {
                    ...responseData,
                    message: getResponseMessage(data)
                }
            })
            return responseData
        }
    } catch (error) {
        dispatch({
            type: 'TEMPLATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const archiveTemplate = (templateId) => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.put('/api/product-template/archive/' + templateId, {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'TEMPLATE_ARCHIVE_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'TEMPLATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const importTemplates = ({ rows, sheetName } = {}) => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/product-template/import', { rows, sheetName }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            const responseData = getResponseData(data)
            dispatch({
                type: 'TEMPLATE_IMPORT_SUCCESS',
                payload: {
                    ...responseData,
                    message: getResponseMessage(data)
                }
            })
            return responseData
        }
    } catch (error) {
        dispatch({
            type: 'TEMPLATE_ERROR',
            payload: getErrorMessage(error)
        })
        throw error
    }
}

export const resetTemplateResult = () => (dispatch) => {
    dispatch({ type: 'TEMPLATE_RESET_RESULT' })
}
